import { render } from "./DssView.vue?vue&type=template&id=628f8567&scoped=true"
import script from "./DssView.vue?vue&type=script&lang=js"
export * from "./DssView.vue?vue&type=script&lang=js"

import "./DssView.vue?vue&type=style&index=0&id=628f8567&scoped=true&lang=scss"

import exportComponent from "P:\\Web\\iacssconference\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-628f8567"]])

export default __exports__